import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getApiHeader } from '../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import ActivationHead from './ActivationHead';
import DropIn from 'braintree-web-drop-in-react';
import { Backdrop, CircularProgress } from '@mui/material';
import Loader from './loader';
import done from '../../../../assets/images/done.png';
import DvsVerification from './DvsVerification';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const isValidNo = /^[0-9]*$/;

const Payment = ({ nextStep, prevStep, handleDataStepOne, setActivationSuccessMsg, setActivationSuccessData, commonSession, selectedPlanData,planDetails, userAccountData, dvsdetails }) => {
   
   
    const [clientToken, setClientToken] = useState('');
    const [loading, setLoading] = useState(false);
    const [dvsStatus, setDvsStatus] = useState(true);

    const instanceRef = useRef(null);
    const [agreedToTerms, setAgreedToTerms] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;
    const apiKey = process.env.REACT_APP_API_TOKEN;


    const [anyError, setAnyError] = useState(false);
   
    const [payment_status, setPayment_status] = useState(userAccountData?.portin_discount_applicable == 0 ? 1 : selectedPlanData?.data?.payment_status);
  
     console.log("userAccountData=====>",userAccountData)
  
  
  
    const [retailer_type, setRetailer_type] = useState('retail');

    const [defaultCard, setdefaultCard] = useState([]);
    const [existingCard, setExistingCard] = useState(0);

    const [no_retry, setNoReTry] = useState(false);


    const handleCheckboxChange = (event) => {
        setAgreedToTerms(event.target.checked);
    };
    
    useEffect(() => {

        
        if (userAccountData?.payment_status === false) {
            setPayment_status(0);
        }else{
            setPayment_status(1);

        }

        if (userAccountData.payment_status == true) {
            setLoading(true);
            fetchDefaultCard();
        }


        console.log("selectedPlanData_____>",selectedPlanData);
        console.log("planDetails--------->",planDetails);
        console.log("userAccountData--------->",userAccountData);

    }, []);


    const fetchDefaultCard = async () => {
        const headers=await getApiHeader();
        try {
            const response = await axios.get(`${apiUrl}retailer-default-card`,
                {
                    headers: headers,
                }
            );

            if(response?.status===200){
                if(response?.data?.data?.payment_methods){
                    if(response?.data?.data?.payment_methods?.last4){
                        setdefaultCard(response.data.data.payment_methods);
                        setExistingCard(1);
                        setLoading(false);
                    }else{
                        fetchToken();
                    }
                    
                }
            }else{
                fetchToken();
            }

        } catch (error) {

            fetchToken();
           
        }
    };



    const handlePaymentSubmit = async () => {


        if(no_retry === true){

            swal("", 'Oops! Something went wrong. Please contact Telsim Dealer Support', "error");

            return;
        }

        if(payment_status === 1 && existingCard===0 && userAccountData.payment_status == true){
            if (!instanceRef.current) return;
        }

        

        try {
            setLoading(true);


            let nonce = null;
            if (instanceRef.current && existingCard===0) {
                const paymentMethod = await instanceRef.current.requestPaymentMethod();
                nonce = paymentMethod.nonce;
            }

            const headers = await getApiHeader();

            const post_data = {
                session_id: commonSession,
                credit_status_ptc: "NO",
                ...(nonce && { payment_method_nonce: nonce }),
                default_Card:existingCard
            };

            const response = await axios.post(`${apiUrl}activation/update`, post_data , { headers: headers });

            setActivationSuccessMsg(response.data.message)
            setActivationSuccessData(response.data.data)
            nextStep()

        } catch (error) {
            var er_msg = '';
            console.log("error--->", error);
            if (error.name === "DropinError") {
                swal("Error in Payment", error.message, "warning");
            } else if (error.response?.data?.message) {
                
                var er_msg = error.response.data.message;

                if(error?.response?.data?.data?.no_retry === true){
                    setNoReTry(true);
                }

                if(error?.response?.data?.data?.id_failed === true){
                   

                    swal("", er_msg, "warning");

                    setDvsStatus(false);

                    var er_msg = '';
                }

            } else {
                var er_msg = "Unexpected error, Please try again";
            }


            if(er_msg !== ''){
                swal({
                  title: "",
                  text: er_msg,
                  type: "error",
                  confirmButtonText: "OK"
                }).then(function() {
                 location.reload(); 
                });
            }


        } finally {
            setLoading(false);
        }
    };

    const fetchToken = async () => {
        setLoading(true)
        const headers=await getApiHeader();
        try {
            const response = await axios.get(`${apiUrl}activation/client_token`,
                {
                    headers: headers,
                }
            );
            const clientToken = response.data.data.clientToken;

            setClientToken(clientToken);
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    };




    const setActivationSuccessMsgChild = (data) => {
        setActivationSuccessMsg(data);
    };
    const setActivationSuccessDataChild = (data) => {
        setActivationSuccessData(data);

        nextStep();
    };


    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <ActivationHead />
                
                {dvsStatus === true ?

                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                        {loading === true && (
                            <Loader />
                        )}

                        <h6>Confirmation</h6>
                        <hr />
                        <br />

                        <div className="ad-mb-result add-mb-payment">

                            <div className="col-lg-7">
                                <div className="col-lg-6 add-mb-6">
                                    <div className="details-block cd-block">
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Customer Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                <td>{userAccountData.customer_name}</td>
                                                </tr>
                                                <tr>
                                                    <td >{userAccountData.email}</td>
                                                </tr>
                                                <tr>
                                                    <td >DOB: {userAccountData.user_dob}</td>
                                                </tr>

                                                <tr>
                                                        <td style={{
                                                            wordWrap: 'break-word',
                                                            wordBreak: 'break-word',
                                                            whiteSpace: 'normal',
                                                            maxWidth: '300px',
                                                            overflow: 'hidden',
                                                        }}
                                                        >Address: {userAccountData.address}</td>
                                                    </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="details-block pl-block">
                                        <table className="text-left">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Plan Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                        <td>
                                                            {selectedPlanData?.data?.plan_amount > selectedPlanData?.data?.plan_sell_amount ? (
                                                                <>
                                                                    Telsim <span style={{ textDecoration: "line-through" }}> ${selectedPlanData?.data?.plan_amount}</span>
                                                                    <span>  ${selectedPlanData?.data?.plan_sell_amount}</span> Prepaid Pack
                                                                </>
                                                            ) : (
                                                                selectedPlanData?.data?.plan_name
                                                            )}
                                                        </td>
                                                </tr>

                                                <tr>
                                                    <td >{userAccountData.validity} Days Validity</td>
                                                </tr>
                                                {userAccountData.idd_free60_included && (
                                                <tr>
                                                 <td> Free IDD 60 Minutes pack included </td>
                                                </tr>
                                                )}

                                                <tr><td><br/></td></tr>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                        Billing 
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td >
                                                            Plan Amount: <span className="add-mb-tt-pay">
                                                                {userAccountData.plan_amount > userAccountData.plan_sell_amount ? (
                                                                    <>
                                                                        <span style={{textDecoration:"line-through"}}>${userAccountData.plan_amount}</span>
                                                                         <span>  ${userAccountData.plan_sell_amount}</span>
                                                                    </>
                                                                ) : (
                                                                    `$${userAccountData.plan_amount}`
                                                                )}
                                                            </span>
                                                    </td>
                                                </tr>
                                                
                                                {userAccountData.show_full_amount_only === true ? 
                                                <>

                                                    <tr>   
                                                        <td>
                                                            Payable Amount: <span className="add-mb-tt-pay">${userAccountData.plan_amount}</span>
                                                        </td>

                                                    </tr>

                                                </>
                                                :
                                                <>

                                                    <tr> 
                                                        <td >
                                                            Retailer Price: <span className="add-mb-tt-pay">${userAccountData.retailer_price}</span>
                                                        </td>
                                                    </tr> 
                                                     {userAccountData?.premium_number_amount > 0 ? (

                                                        <tr>
                                                            <td>

                                                                Premium Number Amount <span style={{ color: '#d6006d' }}>({userAccountData.premium_category_name})</span>: <span className="add-mb-tt-pay">${userAccountData.premium_number_amount}</span>
                                                                {/* <div style={{ fontStyle: 'italic', color: '#6c6c6c', fontSize: '13px', marginBottom: '5px' }}>
                                                                    {userAccountData.premium_number_amount_text}
                                                                </div> */}

                                                            </td>
                                                        </tr>
                                                    ) : ''}
                                                     {userAccountData?.premium_amount_with_gst > 0 ? (

                                                        <tr>
                                                            <td>

                                                                Premium Number Offer Amount <span style={{ color: '#d6006d' }}>({userAccountData.premium_category_name})</span>: <span className="add-mb-tt-pay">${userAccountData.premium_amount_with_gst}</span>
                                                                <div style={{ fontStyle: 'italic', color: '#6c6c6c', fontSize: '13px', marginBottom: '5px' }}>
                                                                    {userAccountData.premium_number_amount_text}
                                                                </div>

                                                            </td>
                                                        </tr>
                                                    ) : ''}
                                                    
                                                    
                                                    <tr> 
                                                        <td >
                                                            Wallet Credit Used: <span className="add-mb-tt-pay"> ${Number(userAccountData.wallet_credit_used).toFixed(2)}</span>
                                                        </td>
                                                    </tr>  

                                                    <tr>   
                                                        <td >
                                                            Payable Amount: <span className="add-mb-tt-pay">${payment_status === 1 ? (
                                                                <>
                                                                {Number(userAccountData.payment_amount).toFixed(2)}
                                                                </>
                                                                ): Number(0).toFixed(2) }
                                                              
                                                                </span>
                                                        </td>

                                                    </tr>
                                                </>
                                                }


                                            </tbody>
                                        </table>
                                    </div>

                                </div>


                                <div className="col-lg-6 add-mb-6">
                                    <div className="details-block cd-block">
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            SIM Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>SIM : {userAccountData.sim}</td>
                                                </tr>
                                               
                                                {selectedPlanData.data.plan_type === "reference_number" &&
                                                    (
                                                        <tr>
                                                            <td><p>Reference Number : {userAccountData.reference_number}</p></td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="details-block pl-block">
                                        <table className="text-left">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Mobile Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                <td>Type : {userAccountData.mobile_selection_type === "new" ? "New Activation" : "PortIn"}  </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Number: {userAccountData.mobile_number}
                                                    </td>
                                                </tr>
                                  
                                                {userAccountData.mobile_selection_type === "portin" && (
                                                    <>
                                                        <tr>
                                                            <td >
                                                                PortIn Provider : {userAccountData.mobile_provider}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                PortIn Type :  {userAccountData.port_service_type}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                           {userAccountData.port_service_type === "Pre-paid"
                                                            ? (<td > PortIn DOB : {userAccountData.port_dob}</td>) : (<td>Account Number: {userAccountData.port_account_id} </td>) }
                                                        </tr>
                                                        <tr>
                                                        <td>
                                                            {userAccountData.port_in_authority_date ? (
                                                                `PortIn Authority Date : ${userAccountData.port_in_authority_date}`
                                                            ) : (
                                                                ''
                                                            )}
                                                        </td>
                                                    </tr>
                                                    </>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>

                           
                                </div>
                                <br></br>
                                <div style={{width:'100%'}} className="details-block cd-block">
                                {payment_status === 1 && (
                                     <div className="col-lg-12 noPayment noheight">
                                        
                                        <p><i className="fa fa-info"></i> Please check the activation details and confirm activation</p>
                                        
                                    </div>
                                )}
                                </div>
                            </div>
                           
                            {/*----------------- Payment section ---------------*/}

                           
                            <div className="col-lg-5 payment-secion">
                                {payment_status === 1 && (

                                    <div className="pay-btree-block">
                                        <span className="amount-mention">*All amounts are mentioned in AUD </span>

                                        {(defaultCard && existingCard === 1) ?

                                            <div className="defaultCard col-lg-12">
                                                <div className="defaultCardBox">
                                                    <p>Paying With Card</p>
                                                    <ul className="defaultCardDetails">
                                                        <li>
                                                            <img src={defaultCard.imageUrl} />
                                                        </li>
                                                        <li>
                                                            <span>Ending In {defaultCard.last4}</span>
                                                            <span>{defaultCard.cardType}</span>
                                                        </li>
                                                        <li>
                                                            <img src={done} />
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            :

                                            <>
                                           
                                                    {clientToken && (
                                                        <>
                                                            <label className='dealer-responsive-label'> Please use payment card details of dealer. Do not use customer payment card details here. </label>
                                                            <DropIn
                                                                options={{ authorization: clientToken }}
                                                                onInstance={(instance) => (instanceRef.current = instance)}
                                                            />
                                                        </>
                                                    )}

                                            </>
                                        }

                                    </div>

                                )}




                                {payment_status === 0 && (
                                <div className="noPayment">
                                    <p><i className="fa fa-info"></i></p>
                                    <p>Please check the activation details and confirm activation</p>
                                    
                                </div>
                                )}


                                <div className="pay-btree-block">
                                    <label className="check-box add-mb-accept-pay">
                                        I have read and accept the <a target="_blank" href='https://www.telsim.com.au/website-terms-conditions/'>Terms & Conditions</a>, the Acceptable Use Policy,
                                        the <a target="_blank" href='https://www.telsim.com.au/website-privacy-policy/'>Privacy Policy</a> for my Telsim service.
                                        <input type="checkbox" required="" id="agreeTerms" checked={agreedToTerms}
                                            onChange={handleCheckboxChange} title="Please check and agree to the terms and conditions" />
                                        <span className="tick"></span>
                                    </label>
                                </div>
                        </div>

                    </div>


                    <br />
                        
                            <div className="button-container add-mb-button-container">

                                {no_retry === false ? 
                                    
                                    <button className="button btn btn-danger" onClick={prevStep}>
                                            Back
                                    </button>
                                :
                                    <button className="button btn btn-danger" style={{visibility:'hidden'}}>
                                            Back
                                    </button>

                                }

                                <button
                                    className="button btn btn-danger ad-mb-button-next"
                                    disabled={!agreedToTerms || loading}
                                    onClick={async () => {
                                        const confirmResult = await swal({
                                            title: "Confirm Activation",
                                            text: "Are you sure you want to activate this plan?",
                                            icon: "warning",
                                            buttons: true,
                                            dangerMode: true,
                                        });

                                        if (confirmResult) {
                                            handlePaymentSubmit();
                                        }
                                    }}
                                >
                                    Confirm & Activate
                                </button>
                            </div>
                       

                    </div>
                </div>

                :
                    <DvsVerification common_Session={commonSession} dvs_Details={dvsdetails} handlesetActivationSuccessMsg={setActivationSuccessMsgChild} handlesetActivationSuccessData={setActivationSuccessDataChild} />
                 
                }

            </DashboardLayout>
        </div>
    );
};

export default Payment;
